import WidgetBetOfTheDay from '@/components/Widgets/WidgetBetOfTheDay.vue';
import WidgetBestCommunityTip from '@/components/Widgets/WidgetBestCommunityTip.vue';
import WidgetAccumulators from '@/components/Widgets/WidgetAccumulators.vue';
import WidgetDroppingOddsTips from '@/components/Widgets/WidgetDroppingOddsTips.vue';
import WidgetLiveBetAlert from '@/components/Widgets/WidgetLiveBetAlert.vue';
import WidgetTrendOfTheDay from '@/components/Widgets/WidgetTrendOfTheDay.vue';
import WidgetStatsAlert from '@/components/Widgets/WidgetStatsAlert.vue';
import WidgetDailyBanker from '@/components/Widgets/WidgetDailyBanker.vue';
import WidgetDailyValueBet from '@/components/Widgets/WidgetDailyValueBet.vue';
import WidgetTrendingTipster from '@/components/Widgets/WidgetTrendingTipster.vue';
import WidgetLiveExpertTip from '@/components/Widgets/WidgetLiveExpertTip.vue';

/**
 * Map feed item type to widget component
 * @param {string} type - Feed item type
 * @returns {object|null} Vue component or null if type is not recognized
 */
export const getWidgetComponent = (type) => {
  const widgetMap = {
    'most-popular-match-preview': WidgetBetOfTheDay,
    'bet-of-the-day': WidgetBestCommunityTip,
    'most-dropping-odd': WidgetDroppingOddsTips,
    'live-fixture-first-goal': WidgetLiveBetAlert,
    'trend-of-the-day': WidgetTrendOfTheDay,
    'matched-trends': WidgetStatsAlert,
    'daily-banker': WidgetDailyBanker,
    'daily-value-bet': WidgetDailyValueBet,
    'trending-tipster': WidgetTrendingTipster,
    'live-expert-tip': WidgetLiveExpertTip,
    'accumulator-of-the-day': WidgetAccumulators,
  };

  return widgetMap[type] || null;
};

/**
 * Map feed item type to analytics-friendly event name
 * @param {string} type - Feed item type
 * @returns {string|null} Analytics event name or null if type is not recognized
 */
export const getWidgetAnalyticsName = (type) => {
  const analyticsMap = {
    'most-popular-match-preview': 'bet_of_the_day',
    'bet-of-the-day': 'best_community_tip',
    'accumulator-of-the-day': 'acca_of_the_day',
    'most-dropping-odd': 'dropping_odds_tips',
    'live-fixture-first-goal': 'live_bet_alert',
    'live-expert-tip': 'live_expert_tip',
    'trend-of-the-day': 'trend_of_the_day',
    'trending-tipster': 'trending_tipster',
    'matched-trends': 'stats_alert',
    'daily-banker': 'daily_banker',
    'daily-value-bet': 'daily_value_bet',
  };

  return analyticsMap[type] || null;
};

/**
 * Get the route path for a widget detail page
 * @param {string} type - Feed item type
 * @param {number} id - Feed item id
 * @returns {string|null} Route path or null if type is not recognized
 */
export const getWidgetRoute = (type, id) => {
  const routeMap = {
    'most-popular-match-preview': `/tabs/widget-bet-of-the-day/${id}`,
    'bet-of-the-day': `/tabs/widget-best-community-tip/${id}`,
    'accumulator-of-the-day': `/tabs/widget-accumulators/${id}`,
    'most-dropping-odd': `/tabs/widget-dropping-odds-tips/${id}`,
    'live-fixture-first-goal': `/tabs/widget-live-bet-alert/${id}`,
    'trend-of-the-day': `/tabs/widget-trend-of-the-day/${id}`,
    'matched-trends': `/tabs/widget-stats-alert/${id}`,
    'daily-banker': `/tabs/widget-daily-banker/${id}`,
    'daily-value-bet': `/tabs/widget-daily-value-bet/${id}`,
    'trending-tipster': `/tabs/widget-trending-tipster/${id}`,
    'live-expert-tip': `/tabs/widget-live-expert-tip/${id}`,
  };

  return routeMap[type] || null;
};
